export const TEXTS = {
    WALLET_PROCEED_TO_LINK: "Link {0} wallet associated with this number",
    WALLET_PROCEED_TO_LINK_V4: "{0} wallet will be linked to ",
    WALLET_DIALOG_SUB_TEXT: "If you don't have a {0} account we will create one for you",
    ADD_MONEY: "Add Money",
};

export const WALLET_DEEP_INTEGRATION_SUFFIX = "-SSO";
